module.exports = __webpack_public_path__ + "static/media/24UHCHR14.74be9893.jpg";